<template>
  <div>
    <b-row>
      <b-col md="4">
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <h3 class="card-title"><b>Detalles del conductor</b></h3>
          </b-card-header>
          <b-card-body class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
              <div class="form-group clearfix">
                <label class="sr-only">Fotografía del conductor</label>
                <base-image-input v-model="$v.imageData.$model" :imagen="getDriverById.profilePicture"/>
                <div class="ml-4 mt-4 float-left text-left">
                  <p class="mb-0"><b>{{ firebaseDriver.driver.firstName }} {{ firebaseDriver.driver.lastName }}</b></p>
                  <p class="mb-0">{{ firebaseDriver.driver.phoneNumber }}</p>
                  <p class="mb-0">{{ firebaseDriver.rate.rating }}<i class="fa fa-star" style="font-size: 0.7em;"></i></p>
                </div>
                <small class="text-danger" v-if="!$v.imageData.required">Campo requerido. No debe estar vacío</small>
              </div>
              <div class="form-group">
                <a-form-item label="Nombre(s)" class="mb-0 pb-0">
                  <a-input
                    placeholder="Nombre(s)"
                    v-model="$v.getDriverById.firstName.$model"
                  />
                  <small class="text-danger" v-if="!$v.getDriverById.firstName.required">Campo requerido. No debe estar vacío</small><br>
                  <small class="text-danger" v-if="!$v.getDriverById.firstName.characters">El campo no debe contener caracteres numéricos ni especiales</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Apellidos" class="mb-0 pb-0">
                  <a-input
                    placeholder="Apellidos"
                    v-model="$v.getDriverById.lastName.$model"
                  />
                  <small class="text-danger" v-if="!$v.getDriverById.lastName.required">Campo requerido. No debe estar vacío</small><br>
                  <small class="text-danger" v-if="!$v.getDriverById.lastName.characters">El campo no debe contener caracteres numéricos ni especiales</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Fecha de nacimiento" has-feedback class="mb-0 pb-0">
                  <a-date-picker placeholder="Seleccionar fecha" @change="changeStartDate" v-model="$v.getDriverById.dateOfBirth.$model" style="width: 100%" />
                  <small class="text-danger" v-if="!$v.getDriverById.dateOfBirth.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Número de teléfono" class="mb-0 pb-0">
                  <a-input
                    placeholder="Número de teléfono"
                    v-model="$v.getDriverById.phoneNumber.$model"
                  />
                  <small class="text-danger" v-if="!validateRegisteredPhone($v.getDriverById.phoneNumber.$model)">Este número de telefono ya ha sido registrado previamente. Intenta con uno diferente.</small>
                  <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.required">Campo requerido. No debe estar vacío</small>
                  <small class="text-danger" v-if="!$v.getDriverById.phoneNumber.phoneNumber">El número de teléfono no es válido, no debe contener espacios. Vuelve a intentarlo.</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Correo electrónico" class="mb-0 pb-0">
                  <a-input
                    placeholder="Correo electrónico"
                    v-model="$v.getDriverById.email.$model"
                  />
                  <small class="text-danger" v-if="!validateRegisteredEmail($v.getDriverById.email.$model)">Este correo electrónico ya ha sido registrado previamente. Intenta con uno diferente.</small>
                  <small class="text-danger" v-if="!$v.getDriverById.email.required">Campo requerido. No debe estar vacío</small>
                  <small class="text-danger" v-if="!$v.getDriverById.email.email">El correo electrónico no es válido, no debe contener espacios. Vuelve a intentarlo.</small>
                </a-form-item>
                <!-- {{ validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid }}-->
              </div>
              <div class="form-group">
                <a-form-item label="RFC" class="mb-0 pb-0">
                  <a-input placeholder="RFC" v-model="$v.getDriverById.rfc.$model"/>
                  <small class="text-danger" v-if="!$v.getDriverById.rfc.required">Campo requerido. No debe estar vacío</small><br>
                  <small class="text-danger" v-if="!$v.getDriverById.rfc.rfc">El RFC no es válido, no debe contener espacios. Vuelve a intentarlo</small><br>
                  <small class="text-danger" v-if="!validateRegisteredRFC($v.getDriverById.rfc.$model)">Este RFC ya ha sido registrado previamente. Intenta con uno diferente</small>
                </a-form-item>
              </div>
              <h3 class="mb-2">Licencia</h3>
              <div class="form-group">
                <a-form-item label="Número de tarjetón" class="mb-0 pb-0">
                  <a-input placeholder="Número de tarjetón" v-model="$v.getDriverById.cardId.$model" />
                  <small class="text-danger" v-if="!$v.getDriverById.cardId.required">Campo requerido. No debe estar vacío</small><br>
                  <small class="text-danger" v-if="!validateRegisteredCardId($v.getDriverById.cardId.$model)">Este número de tarjetón ya ha sido registrado previamente. Intenta con uno diferente</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item
                    label="Fecha de Vencimiento del Tarjetón"
                    has-feedback
                    class="mb-0 pb-0"
                  >
                    <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate"  @change="changeTarjetonDate" v-model="$v.getDriverById.cardExpiration.$model" style="width: 100%" />
                    <small class="text-danger" v-if="!$v.getDriverById.cardExpiration.required">Campo requerido. No debe estar vacío</small>
                  </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Número de licencia" class="mb-0 pb-0">
                  <a-input placeholder="Número de licencia" v-model="$v.getDriverById.license.$model" />
                  <small class="text-danger" v-if="!$v.getDriverById.license.required">Campo requerido. No debe estar vacío</small>
                  <small class="text-danger" v-if="!validateRegisteredLicense($v.getDriverById.license.$model)">Este número de licencia ya ha sido registrado previamente. Intenta con uno diferente</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item
                    label="Fecha de Vencimiento de la Licencia"
                    has-feedback
                    class="mb-0 pb-0"
                  >
                    <a-date-picker placeholder="Seleccionar fecha" :disabled-date="disabledDate" @change="changeLicenciaDate" v-model="getDriverById.licenseExpiration" style="width: 100%" />
                    <small class="text-danger" v-if="!$v.getDriverById.licenseExpiration.required">Campo requerido. No debe estar vacío</small>
                  </a-form-item>
              </div>
              <h4 class="mt-4">Dirección</h4>
              <div class="form-group">
                <a-form-item label="Calle" class="mb-0 pb-0">
                  <a-input
                    placeholder="Calle"
                    v-model="$v.getDriverById.address.street.$model"/>
                    <small class="text-danger" v-if="!$v.getDriverById.address.street.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Estado" class="mb-0 pb-0">
                  <v-select :options="Object.values(estados)" @input="handleEstadoChange" @select="handleEstadoChange" v-model="$v.getDriverById.address.state.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                  <small class="text-danger" v-if="!$v.getDriverById.address.state.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Municipio" class="mb-0 pb-0">
                  <v-select :options="Object.keys(municipios)" @input="handleMunicipioChange" @select="handleMunicipioChange" v-model="$v.getDriverById.address.city.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                  <small class="text-danger" v-if="!$v.getDriverById.address.city.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Código postal" class="mb-0 pb-0">
                  <v-select :options="Object.keys(codigos)" @input="handleCodigoChange" @select="handleCodigoChange" v-model="$v.getDriverById.address.postalCode.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                  <small class="text-danger" v-if="!$v.getDriverById.address.postalCode.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Colonia" class="mb-0 pb-0">
                  <v-select :options="Object.values(colonias)" v-model="$v.getDriverById.address.suburb.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                  <small class="text-danger" v-if="!$v.getDriverById.address.suburb.required">Campo requerido. No debe estar vacío</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Número Exterior" class="mb-0 pb-0">
                  <a-input
                    placeholder="Número Exterior"
                    v-model="$v.getDriverById.address.extNumber.$model"/>
                    <small class="text-danger" v-if="!$v.getDriverById.address.extNumber.required">Campo requerido. No debe estar vacío</small>
                    <small class="text-danger" v-if="!$v.getDriverById.address.extNumber.alphaNum">Ingresa un número exterior válido</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item label="Número Interior" class="mb-0 pb-0">
                  <a-input
                    placeholder="Número Interior"
                    v-model="$v.getDriverById.address.intNumber.$model"/>
                    <small class="text-danger" v-if="!$v.getDriverById.address.intNumber.alphaNum">Ingresa un número interior válido</small>
                </a-form-item>
              </div>
              <div class="form-group">
                <a-form-item>
                  <button
                  :disabled="!( validateRegisteredCardId($v.getDriverById.cardId.$model) && validateRegisteredRFC($v.getDriverById.rfc.$model) && validateRegisteredLicense($v.getDriverById.license.$model) && validateRegisteredEmail(getDriverById.email) && validateRegisteredPhone(getDriverById.phoneNumber) && !$v.$invalid)"
                    type="submit"
                    class="btn btn-light px-5"
                  >
                    Actualizar
                  </button>
                </a-form-item>
              </div>
            </a-form>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="8">
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <h3 class="card-title"><b>Ubicación del conductor</b></h3>
          </b-card-header>
          <b-card-body class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <DriverMap :firebaseDriver="firebaseDriver" />
          </b-card-body>
          <b-card-footer></b-card-footer>
        </b-card>
        <b-card no-body class="bg-light">
          <b-card-header class="pb-0 border-0">
            <h3 class="card-title"><b>Historial de viajes</b></h3>
          </b-card-header>
          <b-card-body v-if="!loadingTrips" class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <b-table
              :items="trips"
              :fields="fieldsTrips"
              small
              borderless
            >
              <template v-slot:cell(cancelled)="row">
                <span v-if="row.item.cancelled" class="badge badge-danger">Cancelado</span>
                <span v-else class="badge badge-success">Completado</span>
              </template>
              <template v-slot:cell(totalTripAmount)="row">
                $ {{ row.item.totalTripAmount }}
              </template>
              <template v-slot:cell(banderazo)="row">
                $ {{ row.item.banderazo }}
              </template>
              <template v-slot:cell(distance)="row">
                {{ truncateDecimals(row.item.distance) }} km
              </template>
              <template v-slot:cell(duration)="row">
                <span v-if="row.item.duration">{{ row.item.duration }}</span>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(tripSource)="row">
                <b-badge v-if="row.item.tripSource == 'SND'" variant="default">{{ row.item.tripSource }}</b-badge>
                <b-badge v-if="row.item.tripSource == 'PLN'" variant="secondary">{{ row.item.tripSource }}</b-badge>
                <b-badge v-if="row.item.tripSource == 'APP'" variant="success">{{ row.item.tripSource }}</b-badge>
              </template>
            </b-table>
          </b-card-body>
          <b-card-body v-else class="pl-3 pr-3 pt-2 pb-0 bg-white">
            <div class="text-center py-3">
              <b-spinner variant="warning" label="Spinning">Cargando</b-spinner>
            </div>
          </b-card-body>
          <b-card-footer></b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import moment from 'moment'
import BaseImageInput from '@/components/imageInput'
import { required, helpers, alphaNum, numeric } from 'vuelidate/lib/validators'
import { uploadFileS3 } from '../../../s3/s3Up'
import firebase from 'firebase'
import headers from '@/config/headers.js'
import DriverMap from '../../../components/maps/travelMap/DriverMap'
import axios from 'axios'
moment.locale('es-mx')
const characters = helpers.regex('characters', /^[A-Za-z\u00C0-\u017F\s]+$/)
const phoneNumber = helpers.regex('phone', /^[0-9]{10}$/)
const rfc = helpers.regex('rfc', /^([A-ZÑ&]{3,4})+?(?:-?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01]))+?(?:-?)?([A-Z\d]{2})([A-Z\d])$/)
const email = helpers.regex('email', /^\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b$/)
/*  const DRIVERS_QUERY = gql`
query getDrivers{
  getDrivers{
    id
    active
    cardExpiration
    cardId
    firstName
    lastName
    license
    licenseExpiration
    phoneNumber
    profilePicture
    email
    rfc
    dateOfBirth
  },
}
` */
const DRIVER_TRIPS = gql`
query getTripsByDriverId($driverId: Int) {
  getTripsByDriverId(driverId: $driverId) {
    id
    driverId
    concesionId
    concesionNumber
    fareType
    estimatedFare
    date
    duration
    distance
    paymentMethod
    totalTripAmount
    pickUpLat
    pickUpLng
    destinationLat
    destinationLng
    status
    cancelled
    startedAt
    finishedAt
    turno
    distanciaAplicada1
    distanciaAplicada2
    cobroTiempo
    banderazo
    typeOfCharge
    tripOrigin
    tripDestination
    tripSource
    appCharge
    fareByVehicleType
    fixedFareId
    preferential
    extraStartedPrice
    siteId
  }
}
`
/*  const getTripsByConcesionarioIdAndDate = gql`
query getTripsByConcesionarioIdAndDate($concesionarioId: Int, $startDate: String, $endDate: String) {
  getTripsByConcesionarioIdAndDate(concesionarioId: $concesionarioId, startDate: $startDate, endDate: endDate) {
    id
    driverId
    concesionId
    concesionNumber
    fareType
    estimatedFare
    date
    duration
    distance
    paymentMethod
    totalTripAmount
    pickUpLat
    pickUpLng
    destinationLat
    destinationLng
    status
    cancelled
    startedAt
    finishedAt
    turno
    distanciaAplicada1
    distanciaAplicada2
    cobroTiempo
    banderazo
    typeOfCharge
    tripOrigin
    tripDestination
    tripSource
    appCharge
    fareByVehicleType
    fixedFareId
    preferential
    extraStartedPrice
    siteId
  }
}
` */
const UPDATE_DRIVER_MUTATION = gql`
mutation updateDriver($idEdit: Int, $dateOfBirth: String, $cardExpiration: String, $firstName: String, $lastName: String, $license: String, $licenseExpiration: String, $phoneNumber: String, $profilePicture: String, $email: String, $cardId: String, $rfc: String, $city: String, $extNumber: String, $intNumber: String, $postalCode: String, $state: String, $suburb: String, $street: String) {
  updateDriver(id: $idEdit, driver: {
    dateOfBirth: $dateOfBirth
    cardExpiration: $cardExpiration
    firstName: $firstName
    lastName: $lastName
    license: $license
    licenseExpiration: $licenseExpiration
    phoneNumber: $phoneNumber
    profilePicture: $profilePicture
    email: $email
    cardId: $cardId
    rfc: $rfc
    driverAddress: {
      city: $city
      extNumber: $extNumber
      intNumber: $intNumber
      postalCode: $postalCode
      state: $state
      suburb: $suburb
      street: $street
    }
  }
  ){
    id
    active
    cardExpiration
    cardId
    createdAt
    firstName
    lastName
    license
    licenseExpiration
    phoneNumber
    profilePicture
    cognitoUsername
    email
    rfc
    driverAddress{
      id
      city
      extNumber
      intNumber
      postalCode
      state
      suburb
      street
    }
  }
}`
export default {
  data() {
    return {
      error: null,
      disabledButton: false,
      imageData: null,
      imageLoadData: null,
      selectedActive: '1',
      optionsActive: [
        { text: 'Sí', value: '1' },
        { text: 'No', value: '0' },
      ],
      fieldsTrips: [
        // { key: 'concesionNumber', label: '# Concesión' },
        { key: 'tripSource', label: 'Viaje' },
        { key: 'startedAt', label: 'Fecha' },
        { key: 'fareType', label: 'Tarifa' },
        { key: 'turno', label: 'Turno' },
        { key: 'duration', label: 'Duración' },
        { key: 'distance', label: 'Distancia' },
        { key: 'banderazo', label: 'Banderazo' },
        { key: 'totalTripAmount', label: 'Total' },
        { key: 'cancelled', label: 'Completado' },
      ],
      trips: [],
      objectFile: [],
      id: this.$route.params.id,
      form: this.$form.createForm(this),
      getDriverById: {
        active: this.$route.params.active,
        cardExpiration: this.$route.params.cardExpiration,
        cardId: this.$route.params.cardId,
        firstName: this.$route.params.firstName,
        lastName: this.$route.params.lastName,
        license: this.$route.params.license,
        licenseExpiration: this.$route.params.licenseExpiration,
        phoneNumber: this.$route.params.phoneNumber.replace('+52', ''),
        profilePicture: this.$route.params.profilePicture,
        email: this.$route.params.email,
        address: {
          city: this.$route.params.driverAddress ? this.$route.params.driverAddress.city : '',
          extNumber: this.$route.params.driverAddress ? this.$route.params.driverAddress.extNumber : '',
          intNumber: this.$route.params.driverAddress ? this.$route.params.driverAddress.intNumber : '',
          postalCode: this.$route.params.driverAddress ? this.$route.params.driverAddress.postalCode : '',
          state: this.$route.params.driverAddress ? this.$route.params.driverAddress.state : '',
          suburb: this.$route.params.driverAddress ? this.$route.params.driverAddress.suburb : '',
          street: this.$route.params.driverAddress ? this.$route.params.driverAddress.street : '',
        },
        rfc: this.$route.params.rfc ? this.$route.params.rfc : '',
        dateOfBirth: this.$route.params.dateOfBirth ? this.$route.params.dateOfBirth : '',
      },
      firebaseDriver: {},
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredEmailDrivers: { a: 5 },
      registeredPhoneDrivers: {},
      registeredCardId: {},
      registeredLicense: {},
      registeredRFC: {},
      estados: ['Ciudad de México', 'Aguascalientes', 'Baja California', 'Baja California Sur', 'Campeche',
        'Coahuila de Zaragoza', 'Colima', 'Chiapas', 'Chihuahua', 'Durango', 'Guanajuato', 'Guerrero',
        'Hidalgo', 'Jalisco', 'México', 'Michoacán de Ocampo', 'Morelos', 'Nayarit', 'Nuevo León',
        'Oaxaca', 'Puebla', 'Querétaro', 'Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora',
        'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz de Ignacio de la Llave', 'Yucatán', 'Zacatecas'],
      municipios: [],
      codigos: [],
      colonias: [],
      data: {},
      loadingTrips: true,
      failCopy: 'No se encontró al conductor en el mapa. Intenta más tarde, si el problema persiste ponte en contacto con el administrador.',
    }
  },
  methods: {
    async getFirebaseDriver(driverId) {
      try {
        const driver = await firebase.firestore().collection('drivers').where('driver.id', '==', driverId).get()
        if (driver.docs.length === 0) {
          this.makeToast(true, 'danger', 'Error', this.failCopy)
          return
        }
        this.firebaseDriver = driver.docs[0].data()
      } catch (error) {
        this.makeToast(true, 'danger', 'Error', this.failCopy)
      }
    },
    async getDriverTrips(driverId) {
      try {
        console.log('getDriverTrips', moment().format('YYYY-MM-DD'))
        const trips = await this.$apollo.query({ query: DRIVER_TRIPS, context: headers(), variables: { driverId: this.$route.params.id } })
        console.log('trips', trips)
        if (trips.data.getTripsByDriverId) {
          this.trips = [...this.trips, ...trips.data.getTripsByDriverId]
          this.loadingTrips = false
        } else {
          this.makeToast(true, 'danger', 'Error', this.failCopy)
          this.loadingTrips = false
          return
        }
      } catch (err) {
        this.makeToast(true, 'danger', 'Error', this.failCopy)
        this.loadingTrips = false
      }
    },
    changeStartDate(event) {
      this.getDriverById.dateOfBirth = event ? this.defineDate(event._d) : this.todayDate()
    },
    validateRegisteredEmail(email) {
      const registredEmail = this.registeredEmailDrivers[email.trim()]
      return !registredEmail
    },
    validateRegisteredPhone(phone) {
      const phoneRegistered = this.registeredPhoneDrivers['+52' + phone]
      return !phoneRegistered
    },
    validateRegisteredCardId(cardId) {
      return !this.registeredCardId[cardId.trim()]
    },
    validateRegisteredLicense(license) {
      return !this.registeredLicense[license.trim()]
    },
    validateRegisteredRFC(rfc) {
      return !this.registeredRFC[rfc.trim()]
    },
    handleEstadoChange(estado) {
      if (estado === null) {
        this.resetData()
      } else {
        this.data = require(`../../../services/data/${estado}.json`)
        this.municipios = this.data[estado]
        this.resetData()
      }
    },
    resetData() {
      this.colonias = []
      this.codigos = []
      this.getDriverById.address.city = ''
      this.getDriverById.address.suburb = ''
      this.getDriverById.address.postalCode = ''
    },
    handleMunicipioChange(municipio) {
      this.colonias = []
      this.codigos = municipio ? this.data[this.getDriverById.address.state][municipio] : []
      this.getDriverById.address.suburb = ''
      this.getDriverById.address.postalCode = ''
    },
    handleCodigoChange(codigo) {
      this.colonias = codigo === null ? [] : this.data[this.getDriverById.address.state][this.getDriverById.address.city][codigo]
      this.getDriverById.address.suburb = ''
    },
    defineDate(date) {
      const dates = new Date(date)
      const year = (dates.getFullYear())
      let month = (parseInt(dates.getMonth() + 1))
      let day = (dates.getDate())
      month = month < 10 ? `0${month}` : month
      day = day < 10 ? `0${day}` : day
      //
      return [year, month, day].join('-')
    },
    changeTarjetonDate(event) {
      this.getDriverById.cardExpiration = event ? this.defineDate(event._d) : this.todayDate()
    },
    changeLicenciaDate(event) {
      this.getDriverById.licenseExpiration = event ? this.defineDate(event._d) : this.todayDate()
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    disabledDate(current) {
      return current < moment().add(-1, 'days')
    },
    async handleSubmit(e) {
      this.disabledButton = true
      e.preventDefault()

      if (this.imageData.name) {
        this.objectFile.fileExtension = this.imageData.name.split('.').pop()
        this.objectFile.fileUploaded = this.imageData
        const data = await uploadFileS3(this.objectFile)
        this.imageLoadData = data.Location
      }
      this.$apollo.mutate({
        mutation: UPDATE_DRIVER_MUTATION,
        variables: {
          idEdit: parseInt(this.id),
          cardExpiration: this.getDriverById.cardExpiration,
          firstName: this.getDriverById.firstName,
          lastName: this.getDriverById.lastName,
          license: this.getDriverById.license.trim(),
          licenseExpiration: this.getDriverById.licenseExpiration,
          phoneNumber: '+52' + this.getDriverById.phoneNumber,
          profilePicture: this.imageLoadData || this.getDriverById.profilePicture,
          email: this.getDriverById.email.trim(),
          cardId: this.getDriverById.cardId.trim(),
          rfc: this.getDriverById.rfc.trim(),
          city: this.getDriverById.address.city,
          extNumber: this.getDriverById.address.extNumber,
          intNumber: this.getDriverById.address.intNumber,
          postalCode: this.getDriverById.address.postalCode,
          state: this.getDriverById.address.state,
          suburb: this.getDriverById.address.suburb,
          street: this.getDriverById.address.street,
          dateOfBirth: this.getDriverById.dateOfBirth,
        },
        context: headers(),
      })
        .then(({ data }) => {
          const driver = data.updateDriver
          console.log(driver)
          console.log(this.getDriverById.dateOfBirth, 'dob')
          firebase.firestore().collection('drivers').doc(String(driver.id)).get()
            .then(data => {
              console.log(data.exists)
              if (data.exists) {
                firebase.firestore().collection('drivers').doc(String(driver.id)).update({ driver: driver })
                  .then(data => {
                    console.log(data)
                    const email = this.getDriverById.email.trim()
                    axios({
                      method: 'get',
                      url: `https://newaccount1617024997354.freshdesk.com/api/v2/search/contacts?query="email:'${email}'"`,
                      auth: {
                        username: 'I6N50w2FTsSQYvqj2',
                        password: 'x',
                      },
                    }).then(result => {
                      console.log('result', result)
                      if (result.length > 0) {
                        const contact = result[0]
                        axios({
                          method: 'put',
                          url: `https://newaccount1617024997354.freshdesk.com/api/v2/contacts/${contact.id}"`,
                          body: {
                            name: this.getDriverById.firstName + ' ' + this.getDriverById.lastName,
                            mobile: '+52' + this.getDriverById.phoneNumber,
                            email: this.getDriverById.email.trim(),
                            fecha_de_nacimiento: this.getDriverById.dateOfBirth,
                            custom_fields: {
                              rfc: this.getDriverById.rfc.trim(),
                              fecha_de_vencimiento_del_tarjetn: this.getDriverById.cardExpiration,
                              nmero_de_tarjetn: this.getDriverById.cardId.trim(),
                              id_de_la_licencia: this.getDriverById.license.trim(),
                              fecha_de_vencimiento_de_la_licencia: this.getDriverById.licenseExpiration,
                              cp: this.getDriverById.address.postalCode,
                              ciudad: this.getDriverById.address.city,
                              no_exterior: this.getDriverById.address.extNumber,
                              no_interior: this.getDriverById.address.intNumber,
                              estado: this.getDriverById.address.state,
                              colonia: this.getDriverById.address.suburb,
                              calle: this.getDriverById.address.street,
                            },
                          },
                          auth: {
                            username: 'I6N50w2FTsSQYvqj2',
                            password: 'x',
                          },
                        })
                      }
                    })
                  })
                  .catch(error => {
                    console.log(error)
                  })
              }
            })
            .catch(error => {
              console.log(error)
            })
          // this.$router.push('/conductores/getDrivers')
        })
        .catch(error => {
          this.disabledButton = false
          console.log(error)
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
    },
    truncateDecimals(amount) {
      if (!amount) { return '0.00' }
      return parseFloat(amount).toFixed(2)
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  created() {
    this.getFirebaseDriver(this.$route.params.id)
    this.getDriverTrips(this.$route.params.id)
    //
    if (this.$route.params.driverAddress) {
      this.data = require(`../../../services/data/${this.getDriverById.address.state}.json`)
      this.municipios = this.data[this.getDriverById.address.state]
      this.codigos = this.municipios[this.getDriverById.address.city]
      this.colonias = this.codigos[this.getDriverById.address.postalCode]
    }
  },
  validations: {
    imageData: { required },
    getDriverById: {
      dateOfBirth: { required },
      firstName: { required, characters },
      lastName: { required, characters },
      cardExpiration: { required },
      cardId: { required },
      phoneNumber: { required, phoneNumber },
      email: { required, email },
      license: { required },
      licenseExpiration: { required },
      rfc: { required, rfc },
      address: {
        city: { required },
        state: { required },
        extNumber: { required, alphaNum },
        intNumber: { alphaNum },
        postalCode: { required, numeric },
        suburb: { required },
        street: { required },
      },
    },
  },
  components: {
    BaseImageInput,
    DriverMap,
  },
}
</script>
